// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__1uC3A","list":"BalanceDue_list__2jald","listRow":"BalanceDue_listRow__2HBw4","total":"BalanceDue_total__1Z_A_"};